// tokenVerificationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const tokenVerificationSlice = createSlice({
  name: "tokenVerification",
  initialState: {
    verificationType: null,
  },
  reducers: {
    setVerificationType(state, action) {
      state.verificationType = action.payload;
    },
  },
});

export const { setVerificationType } = tokenVerificationSlice.actions;
export default tokenVerificationSlice.reducer;
